"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCommunicatorError = void 0;
class MobileCommunicatorError extends Error {
    constructor(errorMessage) {
        super(errorMessage);
    }
}
exports.MobileCommunicatorError = MobileCommunicatorError;
//# sourceMappingURL=mobileCommunicator.errors.js.map